import Description from "@components/CustomTypography/Description/Description"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
// import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import {direction} from "@customTypes/customTypes"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./StudioFeatureCard.module.scss"

type Props = {
	data: AdvancedSideAssetMainContent
	direction: direction
}

const StudioFeatureCard = (props: Props) => {
	return (
		<div
			className={`${styles.container} ${styles[props.direction]}`}
			id={props.data.sectionid?.replace("#", "")}
		>
			<div className={`${styles.contentBox}`}>
				<Title
					className={`${styles.title}`}
					content={props.data.title}
					fontWeight={600}
					size={"M"}
				/>
				<Description content={props.data.content} fontWeight={400} />
				<ButtonSwitcher buttonsList={props.data} />
			</div>
			{props.data.preview && (
				<NewResponsiveImage
					{...props.data.preview}
					containerClassName={styles.AssetBox}
					imageClassName={styles.image}
				/>
			)}
		</div>
	)
}

export default StudioFeatureCard
